"use client";
import * as React from "react";
import { ToggleSwitchProps } from "../types";
import styles from "./index.module.css";

function ToggleSwitch(props: ToggleSwitchProps) {
  return (
    <label className={styles.toggle}>
      {props.label}
      <input
        type="checkbox"
        className={`${styles.input} ${styles["sr-only"]}`}
        onChange={(event) => props.handleChange(event)}
        checked={props.checked}
        disabled={props.disabled}
      />
      <span className={styles.display} />
    </label>
  );
}

export default ToggleSwitch;
